'use client';

import { c as _c } from "react/compiler-runtime";
import { CardSlider, CardSliderList, CardSliderListItem } from '@7f-ui/components/card-slider/card-slider';
import type { AccommodationRate } from '@data-access/graphql/schema.types';
import { setSelectedRoomRate } from '@feat/feat-room-picker/actions';
import { useSelectedRoomRate } from '@feat/feat-room-picker/store';
import { trackClickCta } from '@feat/feat-tracking/cta';
import { RadioGroup } from '@headlessui/react';
import { shopTestId } from '@utils/utils-shop-test-ids';
import type { RefObject } from 'react';
import { useState } from 'react';
import type { AvailableRoom } from '../../hooks/use-available-rooms';
import { getLowestRate } from '../../utils/get-lowest-rate';
import { RATES_WIDTH, Rates } from './rates';
type RatesListProps = {
  room: AvailableRoom;
  sliderListRef: RefObject<HTMLUListElement | null>;
  canScrollRight: boolean;
  onSelectRate?: (rate: AccommodationRate, room: AvailableRoom) => void;
  selectedRate?: AccommodationRate;
  canScrollLeft: boolean;
  isCheapestRoom: boolean;
};
export function RatesList(t0) {
  const $ = _c(23);
  const {
    room,
    isCheapestRoom,
    sliderListRef,
    canScrollRight,
    onSelectRate,
    selectedRate,
    canScrollLeft
  } = t0;
  const [expandedDetails, setExpandedDetails] = useState(false);
  const {
    rate: selectedRoomRate
  } = useSelectedRoomRate();
  let t1;
  if ($[0] !== room.rates) {
    t1 = getLowestRate(room.rates);
    $[0] = room.rates;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const lowestRateId = t1.id;
  let t2;
  if ($[2] !== onSelectRate || $[3] !== room || $[4] !== sliderListRef.current) {
    t2 = rate => {
      const index = room.rates.findIndex(value => value.id === rate.id);
      sliderListRef.current?.scrollTo({
        left: index * RATES_WIDTH,
        behavior: "smooth"
      });
      trackClickCta("select room", {
        selection: room.title,
        type: "accommodation"
      });
      if (onSelectRate) {
        return onSelectRate(rate, room);
      }
      setSelectedRoomRate(room, rate);
    };
    $[2] = onSelectRate;
    $[3] = room;
    $[4] = sliderListRef.current;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const handleChange = t2;
  const t3 = selectedRate ?? selectedRoomRate ?? undefined;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = shopTestId("RatesList.list");
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== expandedDetails || $[8] !== isCheapestRoom || $[9] !== lowestRateId || $[10] !== room.rates) {
    let t6;
    if ($[12] !== expandedDetails || $[13] !== isCheapestRoom || $[14] !== lowestRateId) {
      t6 = rate_0 => <CardSliderListItem key={rate_0.id}><Rates value={rate_0} isLowestPrice={rate_0.id === lowestRateId && isCheapestRoom} expandedDetails={expandedDetails} setExpandedDetails={setExpandedDetails} /></CardSliderListItem>;
      $[12] = expandedDetails;
      $[13] = isCheapestRoom;
      $[14] = lowestRateId;
      $[15] = t6;
    } else {
      t6 = $[15];
    }
    t5 = room.rates.map(t6);
    $[7] = expandedDetails;
    $[8] = isCheapestRoom;
    $[9] = lowestRateId;
    $[10] = room.rates;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[16] !== canScrollLeft || $[17] !== canScrollRight || $[18] !== handleChange || $[19] !== sliderListRef || $[20] !== t3 || $[21] !== t5) {
    t6 = <CardSlider><RadioGroup ref={sliderListRef} as={CardSliderList} by="productId" isSlidable={true} value={t3} onChange={handleChange} leftShadow={canScrollLeft} rightShadow={canScrollRight} className="px-6 sm:px-0" data-testid={t4} aria-label={"Option w\xE4hlen"}>{t5}</RadioGroup></CardSlider>;
    $[16] = canScrollLeft;
    $[17] = canScrollRight;
    $[18] = handleChange;
    $[19] = sliderListRef;
    $[20] = t3;
    $[21] = t5;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  return t6;
}